import useResize from '@anm/hooks/useResize';
import { useCallback, useEffect, useRef } from 'react';

import { getSafeMargin } from '../helpers';

import { drawSvg } from './helpers';
import { HorizontalChartProps } from './types';

export const useDrawChart = ({
  data,
  height,
  margin,
  containerRef,
  barMargin = 0,
  maxValueRatio = 1,
  chartWidthRatio = 1,
  barsVerticalPadding = 0,
  barsHorizontalPadding = 0,
  ...otherProps
}: HorizontalChartProps) => {
  const safeMargin = getSafeMargin(margin);
  const chartRef = useRef<HTMLDivElement>(null);

  const maxValue = Math.max(...data.map(({ value }) => value)) * maxValueRatio;

  const heightRatio = height / maxValue;

  const drawProps = {
    data,
    height,
    maxValue,
    chartRef,
    barMargin,
    heightRatio,
    containerRef,
    chartWidthRatio,
    barsVerticalPadding,
    barsHorizontalPadding,
    margin: safeMargin,
    ...otherProps
  };

  const windowWidth = useRef(0);

  const onResize = useCallback(() => {
    const canRedrawSvg = windowWidth.current !== window.innerWidth;

    if (canRedrawSvg) {
      windowWidth.current = window.innerWidth;

      drawSvg(drawProps);
    }

    canRedrawSvg && drawSvg(drawProps);
  }, [drawProps]);

  useResize(onResize);

  useEffect(() => {
    drawSvg(drawProps);
    windowWidth.current = window.innerWidth;
  }, [data, containerRef?.current]);

  return chartRef;
};
